export var GRID_SIZE = 55; // px per grid square (matches BackgroundPatternCanvas)
export var SCALE_MODES = {
    fractionTiles: { gridSquaresPerUnit: 12, label: 'Fraction Tiles' },
    coloredTiles: { gridSquaresPerUnit: 2, label: 'Colored Tiles' },
    // 'other' is no longer offered in the configuration UI — unchecking the
    // "Scale to math tools" toggle produces the identical effect (a 1
    // grid-square-per-unit number line). Kept in the type/map so legacy saved
    // data with `scaleMode: 'other'` still round-trips without errors; the
    // popup migrates such data to `scalingToManipulatives: false` on load.
    other: { gridSquaresPerUnit: 1, label: 'Any other manipulative' },
};
export var ARROWHEAD_SIZE = 31; // px
export var TICK_HEIGHT = 22; // px (total, extends above and below line)
// Matches `.numberLineTick`/`.numberLineCustomTick`'s `border` in
// numberLineManipulative.scss — the tick is a 0-width box with this border on
// each side, centered on its coordinate via `transform: translate(-50%, -50%)`.
export var TICK_BORDER_WIDTH = 2; // px
export var LABEL_OFFSET = 15; // px below line center
export var LINE_Y = GRID_SIZE; // px, vertical position of the main line within SVG (1 grid from top)
export var TOTAL_SVG_HEIGHT = GRID_SIZE * 2; // px, total SVG container height (2 grid squares)
// Soft cap on total grid squares. Set high enough that no realistic classroom
// configuration hits it; the cap stays so a typo (e.g. range = 100000) can't
// freeze the renderer trying to draw tens of thousands of SVG ticks. The
// previous value of 50 was a usability cap exposed to teachers as an error
// message — that message has been removed.
export var MAX_UNITS = 1000;
export var DEFAULT_JUMP_BAR_LENGTH = 4; // grid squares
export var JUMP_BAR_SNAP_THRESHOLD = 20; // px, vertical snap distance
// Vertical distance (px) from the *nearest tile edge* to the number line
// within which a fraction/colored tile snaps. Previously 55 (an entire grid
// row), which felt over-eager — tiles snapped from anywhere in the same row.
// 12 makes the tile have to come essentially "onto" the line before snapping.
export var NL_TILE_SNAP_THRESHOLD = 12;
export var JUMP_BAR_EDGE_SNAP_THRESHOLD = 10; // px, horizontal edge-to-edge snap
export var JUMP_BAR_TICK_SNAP_THRESHOLD = 15; // px, horizontal tick/gridline snap distance
export var DEFAULT_CONFIG = {
    lineMode: 'noTickMarks',
    jumpBarSnapToGrid: false,
    scalingToManipulatives: false,
    scaleMode: 'fractionTiles',
    gridSquaresPerUnit: 1,
    startValue: '0',
    // Default length is 10 whole units. The popup auto-swaps the end down to
    // 2 when the user enables "Scale to math tools" with the Fraction Tiles
    // scale mode (12 grid squares/unit), since at that scaling a length of
    // 2 already approaches the visible canvas at 100% zoom. For all other
    // scaling/non-scaling combinations 10 stays the default.
    endValue: '10',
    interval: '1',
    labelInterval: '1',
    startNum: 0,
    endNum: 10,
    intervalNum: 1,
    labelIntervalNum: 1,
    numberType: 0,
    startNumerator: 0,
    startDenominator: 1,
    endNumerator: 10,
    endDenominator: 1,
    intervalNumerator: 1,
    intervalDenominator: 1,
    labelIntervalNumerator: 1,
    labelIntervalDenominator: 1,
};
